// Passkey am Gerät: einrichten und anmelden. Das Handy fragt dabei Face ID,
// Fingerabdruck oder seinen Code ab – was es ohnehin zum Entsperren nutzt.
// Das Biometrische verlässt das Gerät nie; der Server bekommt nur einen
// öffentlichen Schlüssel (CLAUDE.md, Datenschutz).
//
// Bewusst direkt mit SimpleWebAuthn statt mit dem Better-Auth-Client: zwei
// Funktionen, die man ganz lesen kann, ohne weiteren Baustein.

import { browserSupportsWebAuthn, startAuthentication, startRegistration, WebAuthnError } from "@simplewebauthn/browser";
import { holen, senden, ApiFehler } from "./api.ts";

export function passkeyMoeglich(): boolean {
  return browserSupportsWebAuthn();
}

/** Übersetzt, was beim Passkey schiefgehen kann, in einen Satz für den Bildschirm. */
export function passkeyMeldung(fehler: unknown): string {
  if (fehler instanceof WebAuthnError) {
    if (fehler.code === "ERROR_CEREMONY_ABORTED") return "Abgebrochen. Du kannst es gleich noch einmal versuchen.";
    if (fehler.code === "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED") return "Auf diesem Gerät gibt es schon einen Passkey für dich – melde dich damit an.";
  }
  if (fehler instanceof DOMException && fehler.name === "NotAllowedError") {
    return "Abgebrochen oder nicht erlaubt. Du kannst es gleich noch einmal versuchen.";
  }
  if (fehler instanceof ApiFehler) return fehler.message;
  return fehler instanceof Error ? fehler.message : "Das hat nicht geklappt.";
}

/** Schritt 1 beim ersten Mal: den Code prüfen. Gibt den Namen zurück, für die Begrüßung. */
export async function einladungPruefen(code: string): Promise<string> {
  const antwort = await senden<{ name: string }>("/api/auth/einladung/pruefen", { code });
  return antwort.name;
}

/** Schritt 2: Passkey einrichten – danach ist man angemeldet. */
export async function passkeyEinrichten(): Promise<void> {
  const optionen = await holen<Parameters<typeof startRegistration>[0]["optionsJSON"]>("/api/auth/passkey/generate-register-options");
  const antwort = await startRegistration({ optionsJSON: optionen });
  await senden("/api/auth/passkey/verify-registration", { response: antwort, createSession: true });
}

/** Anmelden mit einem vorhandenen Passkey. */
export async function passkeyAnmelden(): Promise<void> {
  const optionen = await holen<Parameters<typeof startAuthentication>[0]["optionsJSON"]>("/api/auth/passkey/generate-authenticate-options");
  const antwort = await startAuthentication({ optionsJSON: optionen });
  await senden("/api/auth/passkey/verify-authentication", { response: antwort });
}

export async function abmelden(): Promise<void> {
  await senden("/api/auth/sign-out", {});
}
